import { UPDATE_INVITE_INFO_FROM_LEAD_INQUIRY } from '../constants/actionTypes';
import { INVITE_RENTER_TO_APPLY_CLICK, INVITE_TO_APPLY_MODAL_REQUEST_CLOSE } from '../constants/actions';

const initialState = false;

export default function inviteToApplyModal(state = initialState, action) {
  switch (action.type) {
    case UPDATE_INVITE_INFO_FROM_LEAD_INQUIRY:
      return action.payload.inviteInfoFromLeadInquiry ? true : state;
    case INVITE_RENTER_TO_APPLY_CLICK:
      return true;
    case INVITE_TO_APPLY_MODAL_REQUEST_CLOSE:
      return false;
    default:
      return state;
  }
}
